import { permission } from '../Connnection';
import permissionConfig from '../../config/permissionConfig'


function hasPermission(level) {
    return permissionConfig[permission][level]
}

export default hasPermission